import { ActionIcon, ActionIconProps, Button, Group, Header, Space, Text, Box } from '@mantine/core';
import { PropsWithChildren } from 'react';
import ColorSchemeSwitch from '../common/components/ColorSchemeSwitch';
import { NavLinkProps, useLocation } from 'react-router-dom';
import NavLink from '../common/components/NavLink';
import IfAuthenticated from '../features/auth/IfAuthenticated';
import { useAppDispatch } from './hooks';
import { login } from '../features/auth/authSlice';
import AppMenu from './AppMenu';

export function TitleIcon() {
  return (
    <Box sx={{ height: 40, display: 'flex', alignItems: 'center' }}>
      <img
        src={`/logo-horizontal-light.svg`}
        alt="StreamerKit"
        style={{ height: '40px', width: 'auto' }}
      />
    </Box>
  );
}

export function TitleText() {
  return (
    <Group direction="column" spacing={0}>
      <Text size="xl" weight={800}>
        React
      </Text>
    </Group>
  );
}

function NavBarIcon({ children, ...props }: PropsWithChildren<ActionIconProps<any>>) {
  return (
    <ActionIcon variant="hover" size="lg" {...props}>
      {children}
    </ActionIcon>
  );
}

function NavBarButton({ children, type, className, style, ...props }: PropsWithChildren<NavLinkProps>) {
  return (
    <Button
      component={NavLink}
      variant="subtle"
      {...props}
      activeStyle={({ isActive }: { isActive: boolean }) => ({
        borderBottom: isActive ? '1px solid' : undefined,
      })}
    >
      {children}
    </Button>
  );
}

function AppHeader({ noNav = false }: { noNav?: boolean }) {
  const dispatch = useAppDispatch();
  const location = useLocation();

  return (
    <Header height={60} px="lg">
      <Group position="apart" align="center" sx={{ height: '100%' }}>
        <Group align="center">
          <TitleIcon />
          <TitleText />
          <Space />
          {!noNav && (
            <Group spacing={0}>
              <NavBarButton to="/">Início</NavBarButton>
              <IfAuthenticated>
                <NavBarButton to="queue">Fila</NavBarButton>
                <NavBarButton to="history">Histórico</NavBarButton>
              </IfAuthenticated>
            </Group>
          )}
        </Group>
        <IfAuthenticated
          otherwise={
            <Group>
              <ColorSchemeSwitch component={NavBarIcon} />
            </Group>
          }
        >
          <AppMenu />
        </IfAuthenticated>
      </Group>
    </Header>
  );
}

export default AppHeader;
